import { IOrgAddress } from './addressBook';
import { ICommonAddress } from './shipping';

export enum RecipientSidebarModeEnum {
  Add = 'add',
  Edit = 'edit',
}

/** Discriminant for how a recipient row shows its shipping destination. */
export enum ShippingDisplayKindEnum {
  YouProvide = 'you_provide',
  ClaimRecipientDecides = 'claim_recipient_decides',
  ClaimFromList = 'claim_from_list',
  Digital = 'digital',
}

/** How a recipient row renders its destination; `kind` discriminates the union. */
export type TShippingDisplay =
  | { kind: ShippingDisplayKindEnum.YouProvide; overrideAddress: IOrgAddress | null }
  | { kind: ShippingDisplayKindEnum.ClaimRecipientDecides }
  | { kind: ShippingDisplayKindEnum.ClaimFromList }
  | { kind: ShippingDisplayKindEnum.Digital };

export enum RecipientFormVariantEnum {
  Full = 'full',
  Prefill = 'prefill',
  ContactOnly = 'contactOnly',
}

/**
 * How a send resolves its shipping destination. The string values are persisted in
 * drafts (redux-persist) and mapped to the legacy link payload, so they must not change.
 */
export enum ShippingModeEnum {
  YouProvide = 'you_provide',
  ClaimLink = 'claim_link',
  RecipientDecides = 'recipient_decides',
  FromList = 'from_list',
  FixedAddress = 'fixed_address',
}

export type TAddressMode = ShippingModeEnum.YouProvide | ShippingModeEnum.ClaimLink;

export type TClaimLinkMode = ShippingModeEnum.RecipientDecides | ShippingModeEnum.FromList;

export type TMultiKitAddressMode =
  | ShippingModeEnum.RecipientDecides
  | ShippingModeEnum.FromList
  | ShippingModeEnum.FixedAddress;

export type TEffectiveShippingMode =
  | ShippingModeEnum.YouProvide
  | ShippingModeEnum.RecipientDecides
  | ShippingModeEnum.FromList
  | ShippingModeEnum.FixedAddress;

export interface IEffectiveShipping {
  isMultiKit: boolean;
  mode: TEffectiveShippingMode;
  isClaimBased: boolean;
}

export interface ICreateSendRecipient {
  uid: string;
  first_name: string;
  last_name: string;
  email: string;
  phone?: string;
  address: ICommonAddress | null;
  tax_number?: string;
  savedAddressId?: string;
}

export interface ICreateSendRecipientsState {
  addressMode: TAddressMode;
  claimLinkMode: TClaimLinkMode;
  multiKitAddressMode: TMultiKitAddressMode;
  recipients: ICreateSendRecipient[];
  overrideAddress: IOrgAddress | null;
  oneTimeAddress: IOrgAddress | null;
  selectedClaimAddressIds: string[];
}

export type TRecipientsBlockReason =
  | 'no-recipients'
  | 'from-list-needs-2'
  | 'incomplete-recipient'
  | 'business-reason-required'
  | 'crm-record-required'
  | 'crm-status-unknown'
  | 'release-date-required'
  | 'bulk-requires-admin';

export interface IEffectiveCreateSendRecipients {
  isOn: boolean;
  recipients: ICreateSendRecipient[];
}

export interface IRecipientsGate {
  valid: boolean;
  reason: TRecipientsBlockReason | null;
}
